import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const SocialMediaFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M13.627 21.526H9.875v-8.848H8V9.63h1.875V7.8c0-2.487 1.058-3.967 4.066-3.967h2.503v3.05H14.88c-1.171 0-1.249.426-1.249 1.221l-.005 1.526h2.836l-.332 3.048h-2.504v8.848z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
